import React, { useMemo, useState, useEffect } from 'react';
import Card from '../../UI/Card/Card';
import userService from '../../app/services/user.service';
import { toast } from 'react-toastify';
import Loader from '../../UI/loader/loader';
import ImageAnnotation from './ImageAnnotation';
import { useNavigate } from 'react-router-dom';
import SecBTN from '../../UI/SecBTN';
const MediaCropping = ({ uploadId, onNext, onPrevious, currentStatus }) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [annotationMode, setAnnotationMode] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [previewImage, setPreviewImage] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);



  console.log(currentStatus);

  // Fetch PDF images list — extracted so Refresh button can call it too
  const fetchImages = () => {
    if (!uploadId) return;

    setLoading(true);
    userService
      .getPdfImagesList(uploadId)
      .then((response) => {
        setLoading(false);
        const data = response?.pdf_imageslist || [];
        const mappedData = Array.isArray(data)
          ? data.map((item, index) => ({
            pageNo: index + 1,
            imageId: item.img_id || '',
            annotated: item.is_loc_verified === 1 || item.have_diagram === 1,
            qids: item.id_list || 'None',
            isOverflow: item.is_overflow === 1,
            isPType: item.is_p_type === 1,
            isDiscard: item.is_img_discarded === 1,
            isBlur: item.request_for_deblur === 1,
            textExtracted: item.is_text_extracted === 1 || item.is_text_extracted === true || item.is_text_extracted === 'Yes',
            imgPath: item.img_path,
            pdfFileId: item.pdf_file_id,
            pdfUploadId: item.pdf_upload_id,
          }))
          : [];
        setItems(mappedData);
        if (mappedData.length === 0) {
          toast.info("No images found for this upload");
        }
      })
      .catch((err) => {
        console.error("Error fetching PDF images list:", err);
        setLoading(false);
        toast.error("Failed to load PDF images list");
      });
  };

  // Fetch PDF images list when component mounts or uploadId changes
  useEffect(() => {
    fetchImages();
  }, [uploadId]);

  const pageSize = rowsPerPage === 'ALL' ? items.length : rowsPerPage;
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));

  const pagedItems = useMemo(() => {
    if (rowsPerPage === 'ALL') return items;

    const start = (currentPage - 1) * pageSize;
    return items.slice(start, start + pageSize);
  }, [items, currentPage, rowsPerPage]);

  const handleRowsPerPageChange = (e) => {
    const value = e.target.value;
    setRowsPerPage(value === 'ALL' ? 'ALL' : Number(value));
    setCurrentPage(1); // reset to first page
  };

  const toggleOverflow = async (row) => {
    try {
      const payload = {
        img_id: row.imageId,
        is_overflow: row.isOverflow ? 0 : 1
      };

      await userService.saveImageDetails(payload);

      setItems(prev =>
        prev.map(it =>
          it.pageNo === row.pageNo
            ? { ...it, isOverflow: !row.isOverflow }
            : it
        )
      );

      toast.success("Overflow updated");
    } catch (err) {
      console.error(err);
      toast.error("Failed to update overflow");
    }
  };

  // check all pages annotated
  const allAnnotated = useMemo(() => {
    return items.length > 0 && items.every(item => item.annotated === true);
  }, [items]);


  const getImageUrl = (path) => {
    if (!path) return "";

    return `https://cdnqms.motion.ac.in/${path}`;
  };

  const handleViewImage = (row) => {
    const url = getImageUrl(row.imgPath);
    setPreviewImage(url);
  };


  const togglePType = async (row) => {
    try {
      const payload = {
        img_id: row.imageId,
        is_p_type: row.isPType ? 0 : 1
      };

      await userService.saveImageDetails(payload);

      setItems(prev =>
        prev.map(it =>
          it.pageNo === row.pageNo
            ? { ...it, isPType: !row.isPType }
            : it
        )
      );

      toast.success("P-type updated");
    } catch (err) {
      console.error(err);
      toast.error("Failed to update P-type");
    }
  };


  const toggleDiscard = async (row) => {
    try {
      const payload = {
        img_id: row.imageId,
        is_img_discarded: row.isDiscard ? 0 : 1
      };
      await userService.saveImageDetails(payload);
      setItems(prev =>
        prev.map(it =>
          it.pageNo === row.pageNo ? { ...it, isDiscard: !row.isDiscard } : it
        )
      );
      toast.success("Discard updated");
    } catch (err) {
      console.error(err);
      toast.error("Failed to update discard");
    }
  };

  const toggleBlur = async (row) => {
    try {
      const payload = {
        img_id: row.imageId,
        request_for_deblur: row.isBlur ? 0 : 1
      };
      await userService.saveImageDetails(payload);
      setItems(prev =>
        prev.map(it =>
          it.pageNo === row.pageNo ? { ...it, isBlur: !row.isBlur } : it
        )
      );
      toast.success("Blur updated");
    } catch (err) {
      console.error(err);
      toast.error("Failed to update blur");
    }
  };

  const handleAnnotate = (pageNo) => {
    const index = items.findIndex((item) => item.pageNo === pageNo);
    if (index !== -1) {
      setCurrentImageIndex(index);
      setAnnotationMode(true);
    }
  };

  const handleAnnotationSave = async (data) => {
    try {
      const payload = {
        img_id: data.imageId || data.img_id
      };

      if (Array.isArray(data.annotations)) {
        const hasDiagram = data.annotations.length > 0;
        payload.have_diagram = hasDiagram ? 1 : 0;
        payload.is_loc_verified = 1;

        if (hasDiagram) {
          payload.diag_loc = data.annotations;
        }
      }

      if (data.isOverflow !== undefined) {
        payload.is_overflow = data.isOverflow ? 1 : 0;
      }

      if (data.isPType !== undefined) {
        payload.is_p_type = data.isPType ? 1 : 0;
      }

      if (data.isDiscard !== undefined) {
        payload.is_discard = data.isDiscard ? 1 : 0;
      }

      if (data.isBlur !== undefined) {
        payload.is_blur = data.isBlur ? 1 : 0;
      }

      await userService.saveImageDetails(payload);

      // 🔥 IMPORTANT PART
      setItems(prev =>
        prev.map(item =>
          item.pageNo === data.pageNo
            ? { ...item, ...data, annotated: true }
            : item
        )
      );

      toast.success("Saved successfully");
    } catch (err) {
      console.error(err);
      toast.error("Failed to save");
    }
  };

  const handleFinalSaveAndNext = async () => {
    try {
      const payload = {
        upload_id: uploadId,
      }

      await userService.saveAllImagesDetails(payload);

      toast.success("Image annotated successfully");
      onPrevious();
    } catch (err) {
      console.error(err);
      toast.error("Failed to save pages");
    }
  };

  const handlePageNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((p) => p + 1);
    }
  };





  const handleAnnotationNext = () => {
    if (currentImageIndex < items.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    } else {
      // All images annotated, return to table view
      setAnnotationMode(false);
      toast.success('All images have been annotated');
    }
  };

  const handleAnnotationPrevious = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  const handleAnnotationCancel = () => {
    setAnnotationMode(false);
    setCurrentImageIndex(0);
  };

  if (loading) {
    return (
      <Card className="mb-4">
        <div className="text-center p-5">
          <Loader />
          <p className="mt-3">Loading PDF images...</p>
        </div>
      </Card>
    );
  }

  // Show annotation view if in annotation mode
  if (annotationMode && items[currentImageIndex]) {
    const handleAnnotationOverflow = (pageNo) => {
      toggleOverflow(pageNo);
      setItems((prev) =>
        prev.map((item) =>
          item.pageNo === pageNo ? { ...item, isOverflow: !item.isOverflow } : item
        )
      );
    };

    const handleAnnotationPType = (pageNo) => {
      togglePType(pageNo);
      setItems((prev) =>
        prev.map((item) =>
          item.pageNo === pageNo ? { ...item, isPType: !item.isPType } : item
        )
      );
    };

    const handleAnnotationDiscard = (data) => {
      toggleDiscard(data);
      setItems((prev) =>
        prev.map((item) =>
          item.pageNo === data.pageNo ? { ...item, isDiscard: !item.isDiscard } : item
        )
      );
    };

    const handleAnnotationBlur = (data) => {
      toggleBlur(data);
      setItems((prev) =>
        prev.map((item) =>
          item.pageNo === data.pageNo ? { ...item, isBlur: !item.isBlur } : item
        )
      );
    };

    return (
      <ImageAnnotation
        imageData={items[currentImageIndex]}
        onSave={handleAnnotationSave}
        onNext={handleAnnotationNext}
        onPrevious={handleAnnotationPrevious}
        onCancel={handleAnnotationCancel}
        currentIndex={currentImageIndex}
        totalImages={items.length}
        onToggleOverflow={handleAnnotationOverflow}
        onTogglePType={handleAnnotationPType}
        onToggleDiscard={handleAnnotationDiscard}
        onToggleBlur={handleAnnotationBlur}
      />
    );
  }

  return (
    <>
      <div className="mc-topbar">
        <div className="mc-rows-dropdown">
          <label className="me-2">Rows:</label>
          <select
            className="form-select form-select-sm"
            style={{ width: 90, display: 'inline-block' }}
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value="ALL">All</option>
          </select>
        </div>

        <button className="btn btn-secondary btn-sm" onClick={onPrevious}>
          Go to table
        </button>

        <SecBTN className="btn action-btn btn-sm" onClick={fetchImages} disabled={loading}>
          {loading ? '↻ Refreshing...' : '↻ Refresh'}
        </SecBTN>

        {/* ✅ Message + Button Wrapper */}
        <div className="d-flex align-items-center gap-2">

          {currentStatus === 4 && (
            <span className="text-danger small">
              Please click on the Save and Next button to complete the pending extractions 👉
            </span>
          )}

          <button
            className="mc-next"
            disabled={!allAnnotated}
            onClick={handleFinalSaveAndNext}
          >
            Save &amp; Next
          </button>

        </div>
      </div>

      <Card className="mb-4">
        <div className="table-responsive">
          <table className="table table-bordered mb-0 mc-table">
            <thead>
              <tr>
                <th>Page No</th>
                <th>Image ID</th>
                <th>Annotated</th>
                <th>QIDs</th>
                <th>Is Overflow</th>
                <th>Is P-type</th>
                <th>Text Extracted</th>
                <th style={{ width: 260 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pagedItems.map((row) => (
                <tr key={row.pageNo}>
                  <td>{row.pageNo}</td>
                  <td>{row.imageId}</td>
                  <td>{row.annotated ? 'Yes' : 'No'}</td>
                  <td>{row.qids}</td>
                  <td>{row.isOverflow ? 'Yes' : 'No'}</td>
                  <td>{row.isPType ? 'Yes' : 'No'}</td>
                  <td>{row.textExtracted ? 'Yes' : 'No'}</td>
                  <td>
                    <div className="mc-actions">
                      {(currentStatus === 0 || currentStatus == null) && (
                        <>
                          <button
                            className="mc-action-btn"
                            onClick={() => handleAnnotate(row.pageNo)}
                          >
                            Annotate
                          </button>

                          <button
                            className="mc-action-btn"
                            onClick={() => handleViewImage(row)}
                          >
                            View Image
                          </button>

                          {row.isOverflow ? (
                            <button
                              className="mc-action-btn mc-action-danger"
                              onClick={() => toggleOverflow(row)}
                            >
                              Clear Overflow
                            </button>
                          ) : (
                            <button
                              className="mc-action-btn"
                              onClick={() => toggleOverflow(row)}
                            >
                              Mark Overflow
                            </button>
                          )}

                          <button
                            className="mc-action-btn"
                            onClick={() => togglePType(row)}
                          >
                            {row.isPType ? 'Clear P-type' : 'Mark P-type'}
                          </button>
                        </>
                      )}

                      {currentStatus === 1 && (
                        <button
                          className="mc-action-btn"
                          onClick={() => handleViewImage(row)}
                        >
                          View Image
                        </button>
                      )}
                    </div>

                  </td>
                </tr>
              ))}
              {pagedItems.length === 0 && !loading && (
                <tr>
                  <td colSpan={8} className="text-center">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="mc-pagination">
        <button
          className={`mc-page-nav ${currentPage === 1 ? 'disabled' : ''}`}
          onClick={() => currentPage > 1 && setCurrentPage((p) => p - 1)}
        >
          Previous
        </button>

        <div className="mc-page-numbers">
          {Array.from({ length: totalPages }).map((_, idx) => {
            const page = idx + 1;
            return (
              <button
                key={page}
                className={`mc-page-number ${page === currentPage ? 'active' : ''}`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            );
          })}
        </div>

        <button
          className={`mc-next ${currentPage === totalPages ? 'disabled' : ''}`}
          disabled={currentPage === totalPages}
          onClick={handlePageNext}
        >
          Next
        </button>

      </div>
      {previewImage && (
        <div className="mc-modal-backdrop">
          <div className="mc-modal">
            <button
              className="mc-modal-close"
              onClick={() => setPreviewImage(null)}
            >
              ✕
            </button>

            <img
              src={previewImage}
              alt="Preview"
              className="mc-modal-image"
            />
          </div>
        </div>
      )}

    </>
  );
};

export default MediaCropping;

